import Header from '../components/Header.tsx'
import Footer from '../components/Footer.tsx'
import { Link } from 'react-router-dom'

export default function LicensesPage() {
  return (
    <>
      <Header />
      <main className="shell legal-page">
        <article className="prose">
          <h1>Open Source Licenses</h1>
          <p>
            This internal-preview notice identifies the open-source components used
            by the converter. It is not a production-release approval.
          </p>
          <h2>Converter components</h2>
          <ul>
            <li>libheif and libde265 via the HEIC decoder — LGPL-3.0-or-later</li>
            <li>jsPDF — MIT</li>
            <li>JSZip — MIT</li>
          </ul>
          <p>
            Corresponding-source information and the internal artifact manifest are
            retained with the project source. HEVC/H.265 licensing remains subject
            to separate legal review before any release.
          </p>
          <p>
            <Link to="/">← Back to converter</Link>
          </p>
        </article>
      </main>
      <Footer />
    </>
  )
}
